import React from "react";
import { useCurrentFrame, useVideoConfig } from "remotion";
import { VIDEO_FONT_FAMILY } from "../RegisterVideoFonts";
import { resolveActiveWordIndex } from "../lib/captionLogic";
import { resolveCaptionChunk } from "./scenarioExplainerTimeline";

/**
 * Burned-in karaoke captions. Same word-timing model as FlowWordSyncedCaptions
 * (ElevenLabs-style { text, startMs, endMs }, min hold, frozen between words),
 * but chunked into short phrases and sized for phones. Rendered in a fixed-height
 * box so captions never move into platform UI overlays.
 */
export function SocialCaptions({ words, chunks, colors, fontSize, height }) {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();
  const ms = (frame / fps) * 1000;
  const chunk = resolveCaptionChunk(chunks, ms);
  const activeIndex = chunk ? resolveActiveWordIndex(words, ms) : -1;

  return (
    <div
      style={{
        height,
        flexShrink: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {chunk ? (
        <div
          style={{
            maxWidth: "100%",
            padding: `${fontSize * 0.22}px ${fontSize * 0.5}px`,
            borderRadius: fontSize * 0.3,
            background: "rgba(0,0,0,0.62)",
            textAlign: "center",
            fontFamily: VIDEO_FONT_FAMILY,
            fontSize,
            fontWeight: 800,
            lineHeight: 1.18,
            letterSpacing: "-0.5px",
            textWrap: "balance",
            color: colors.text,
            // Two lines max at this size; chunking keeps phrases short.
            overflow: "hidden",
            maxHeight: fontSize * 1.18 * 2 + fontSize * 0.44,
          }}
        >
          {chunk.words.map((word, i) => {
            const active = word.globalIndex === activeIndex;
            return (
              <React.Fragment key={`${word.globalIndex}-${word.text}`}>
                {i > 0 ? " " : null}
                <span style={{ color: active ? colors.accent : colors.text }}>{word.text}</span>
              </React.Fragment>
            );
          })}
        </div>
      ) : null}
    </div>
  );
}
